import { v4 as uuid } from 'uuid';
import { Destination } from './Destination.js';
import maskPII from '../transformations/maskPII.js';
import { filterNullOrUndefined } from '../transformations/filterNullOrUndefined.js';
import { getNonFunctionProperties } from '../transformations/getNonFunctionProperties.js';
export default class AttendeeActivitiesDestination extends Destination {
    constructor() {
        super(...arguments);
        this.name = 'AttendeeActivities';
    }
    async baseTransform(action, data) {
        const { objectId, eventId, accountMappingId, attendeeId, attendeeType, environment, ...rest } = data;
        const restOfAction = getNonFunctionProperties(action, ['data', 'id', 'ts', 'destinations']);
        return {
            type: 'aa_attendee_activities',
            schema_version: 'v1',
            activity_type: action.id,
            activity_id: uuid(),
            account_mapping_id: accountMappingId,
            attendee_type: attendeeType,
            attendee_id: attendeeId,
            event_id: eventId,
            object_id: objectId,
            env: environment,
            ts: action.ts,
            data: maskPII(filterNullOrUndefined({ ...restOfAction, ...rest }))
        };
    }
}
//# sourceMappingURL=AttendeeActivities.js.map